import { DatePipe } from '@angular/common';
import {
  Component,
  Input,
  AfterViewInit,
  ViewChild,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexYAxis,
  ApexLegend,
  ApexXAxis,
  ApexTooltip,
  ApexTheme,
  ApexGrid,
  ApexPlotOptions,
  ApexFill,
} from 'ng-apexcharts';
import { dataFactoring } from '../../dataFactoring';
import {
  CesionarioSummaries,
  DailyAmount,
  DailyDocs,
  DateFilters,
} from '../../interface/data.interface';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: any;
  theme: ApexTheme;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  legend: ApexLegend;
  colors: string[];
  markers: any;
  grid: ApexGrid;
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  labels: string[];
};


import moment from 'moment';

@Component({
  selector: 'app-factoring-docs',
  templateUrl: './factoring-docs.component.html',
  styleUrls: ['./factoring-docs.component.scss'],
})
export class FactoringDocsComponent {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);

  @Input() recieveFilterDate: DateFilters;
  @Input() recieveFilterName: string;
  @Input() dailyDocs: DailyDocs;

  public booleanFlag: boolean = false;

  public gredientChartOptions: Partial<ChartOptions> | any;
  public activeOptionButton = '';
  public todosLosMesesConDatos: any[] = [];

  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });


  constructor() {}
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    const boardDeals: Array<DailyDocs> = changes['dailyDocs'].currentValue;
    this.todosLosMesesConDatos = boardDeals;
    this.generateChart();

    if (changes['dailyDocs'].currentValue !== undefined) {
      this.booleanFlag = true;
      this.todosLosMesesConDatos = boardDeals;
      this.generateChart();
    }
  }

  generateChart() {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    this.gredientChartOptions = {
      series: [
        {
          name: 'Documentos',
          data: Array.isArray(this.todosLosMesesConDatos)
            ? this.todosLosMesesConDatos.map((e) => e.documents)
            : [],
        },
      ],
      chart: {
        zoom: {
          enabled: true,
        },
        height: 350,
        type: 'bar',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        foreColor: '#adb0bb',
        toolbar: {
          show: true,
        },
        dropShadow: {
          position: 'top',
        },
      },
      plotOptions: {
        bar: {
          columnWidth: '60%',
        },
      },
      stroke: {
        curve: 'smooth',
      },
      hover: {
        filter: {
          type: 'lighten',
          value: 0.15,
        },
      },
      xaxis: {
        type: 'datetime',
        categories:  Array.isArray(this.todosLosMesesConDatos)
        ? this.todosLosMesesConDatos.map((e) => e.date)
        : [],
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          gradientToColors: ['#5D87FF'],
          shadeIntensity: 1,
          type: 'horizontal',
          opacityFrom: 1,
          opacityTo: 0.9,
          stops: [0, 100, 100, 100],
        },
      },
      markers: {
        size: 4,
        opacity: 0.9,
        colors: ['#5D87FF'],
        strokeColor: '#fff',
        strokeWidth: 2,
        hover: {
          size: 7,
        },
      },
      yaxis: {
        min: 0,
        max: 10000,
      },
      tooltip: {
        theme: 'dark',
      },
      grid: {
        show: false,
      },
    };
  }

  generateDateRange(startDate: Date, endDate: Date): string[] {
    const dateRange: string[] = [];
    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      dateRange.push(currentDate.toISOString());
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateRange;
  }
  filtrarPorFecha() {
    const dateStart = this.recieveFilterDate!.dateStart;
    const dateEnd = this.recieveFilterDate!.dateEnd;

    const newData = this.gredientChartOptions.series[0].data.filter(
      (data: number, index: number) => {
        const fechaEnCategorias =
          this.gredientChartOptions.xaxis.categories[index];

        return fechaEnCategorias >= dateStart! && fechaEnCategorias <= dateEnd!;
      }
    );

    const newCategories = this.gredientChartOptions.xaxis.categories.filter(
      (fecha: any, index: number) => {
        const fechaMillis = moment(fecha).valueOf();
        const dateStartMillis = moment(dateStart).valueOf();
        const dateEndMillis = moment(dateEnd).valueOf();

        return fechaMillis >= dateStartMillis && fechaMillis <= dateEndMillis;
      }
    );

    this.gredientChartOptions.series[0].data = newData;
    this.gredientChartOptions.xaxis.categories = newCategories;
    this.chart.updateOptions(this.gredientChartOptions);
  }

  // applyFilter() {
  //   const filterValue = this.recieveFilterName!.nameCompany.toLowerCase(); // Convertir a minúsculas

  //   // Filtrar los datos por el nombre que contiene el filtro (comparación insensible a mayúsculas y minúsculas)
  //   const filteredData = dataFactoring.filter((item) => {
  //     return item.name?.toLowerCase().includes(filterValue.trim());
  //   });

  //   const filteredNewData = filteredData.map((item) => item.docs);

  //   const filteredNewDate = filteredData.map((item) =>
  //     moment(item.date).valueOf()
  //   );

  //   // Actualizar las opciones del gráfico con los datos filtrados
  //   this.gredientChartOptions.series[0].data = filteredNewData;

  //   // Actualizar las opciones del gráfico sin filtrar para mostrar el nombre en el eje x
  //   this.gredientChartOptions.xaxis.categories = filteredNewDate;

  //   // Actualizar el gráfico
  //   this.chart.updateOptions(this.gredientChartOptions);
  // }
}
